import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'themes';
import { HelmetProvider } from 'react-helmet-async';
// import ScrollToTop from './components/ScrollToTop';

import { Toaster } from 'react-hot-toast';
import { ConfirmDialogProvider } from 'common/ConfirmDialogProvider';
import { TOAST } from 'themes/colors';

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <ThemeProvider>
          <ConfirmDialogProvider>


            <BrowserRouter>
              <Toaster
                position="top-right"
                gutter={8}
                toastOptions={{
                  duration: 4000,
                  style: {
                    borderRadius: TOAST.borderRadius,
                    background: TOAST.bg,
                    color: TOAST.text,
                    fontSize: '13.5px',
                    fontWeight: 500,
                    padding: '11px 16px',
                    boxShadow: '0 8px 24px rgba(0,0,0,0.18)',
                    maxWidth: '380px',
                  },
                  success: {
                    iconTheme: { primary: TOAST.success, secondary: TOAST.bg },
                  },
                  error: {
                    iconTheme: { primary: TOAST.error, secondary: TOAST.bg },
                  },
                  loading: {
                    iconTheme: { primary: TOAST.loading, secondary: TOAST.bg },
                  },
                }}
              />
              <App />
            </BrowserRouter>
          </ConfirmDialogProvider>
        </ThemeProvider>
      </Provider>
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
